import { Box } from "@chakra-ui/react"
import { useEditorMode } from "@pathwright/blocks-engine"
import { List, QuillEditor } from "@pathwright/blocks/src/shared"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { TOOLBAR_CONFIG_TYPES } from "@pathwright/ui/src/components/quill/toolbar/QuillToolbar"
import sortBy from "lodash/sortBy"
import { useCallback, useMemo } from "react"
import { createSampleCard } from "../utils"
import * as AccordionUI from "./AccordionUI"

const AccordionEdit = (props) => {
  const { onChange, data } = props

  const { mode } = useEditorMode()

  const handleGenerateItem = useCallback(
    ({ order }) => createSampleCard(order),
    [createSampleCard]
  )

  const handleChange = useCallback(
    ({ items }) => onChange({ cards: items }),
    [onChange]
  )

  const renderItem = useCallback(
    ({
      item,
      isAtMin,
      index,
      DragHandle,
      isActive,
      onRemove,
      onUpdate,
      onSetActive
    }) => {
      const handleChangeHTML = (nextHTML) => {
        onUpdate({ attribute: "html", value: nextHTML })
      }

      return (
        <AccordionUI.Item
          index={index}
          title={item.title}
          mode={mode}
          showControls={!isAtMin}
          expanded={isActive}
          onRemove={onRemove}
          onToggleExpand={onSetActive}
          onChangeTitle={onUpdate}
          DragHandle={DragHandle}
        >
          <QuillEditor
            html={item.html}
            onChange={handleChangeHTML}
            placeholder="Enter accordion content..."
            toolbar={TOOLBAR_CONFIG_TYPES.BASIC}
          />
        </AccordionUI.Item>
      )
    },
    [mode, TOOLBAR_CONFIG_TYPES]
  )

  const renderAdd = useCallback(
    ({ onAdd }) => <AccordionUI.Add onClick={onAdd} />,
    []
  )
  const items = useMemo(() => sortBy(data.cards, "order"), [data.cards])

  return (
    <Content.Container style={{ padding: "1.5rem 0" }}>
      <Box boxShadow="0 0 20px 0 rgba(0, 0, 0, 0.1)" backgroundColor="#fff">
        <List
          direction="vertical"
          items={items}
          min={1}
          renderItem={renderItem}
          renderAdd={renderAdd}
          generateItem={handleGenerateItem}
          onChange={handleChange}
          id={props.id}
        />
      </Box>
    </Content.Container>
  )
}

export default AccordionEdit
